/* unplugin-vue-components disabled */import { render } from "./recharge.vue?vue&type=template&id=0ed3b3c6&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"

import "./recharge.vue?vue&type=style&index=0&id=0ed3b3c6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed3b3c6"]])

export default __exports__